export const fixDigits = (str = '') =>
  str.replace(/[\u06F0-\u06F9]/g, d => String(d.charCodeAt(0) - 0x06F0))
     .replace(/[\u0660-\u0669]/g, d => String(d.charCodeAt(0) - 0x0660));
